module.exports = __webpack_public_path__ + "assets/img/u5e707093272e2.1985930b.png";